import React from "react";

import { IgButton } from "@intelligems/ig-theme";
import { Grid } from "@mui/material";

interface WelcomePageProps {
  handleNext: () => void;
}

export const WelcomePage = ({ handleNext }: WelcomePageProps) => {
  return (
    <Grid
      item
      rowSpacing={1}
      container
      alignItems={"center"}
      direction={"column"}
      textAlign={"center"}
    >
      <Grid item>
        <IgButton
          size={"small"}
          sx={{ fontSize: "16px", width: "215px" }}
          variant={"contained"}
          onClick={handleNext}
        >
          Continue
        </IgButton>
      </Grid>
    </Grid>
  );
};
